export const getErrorMessage = (AxiosError: any) => {
  const error: Error = AxiosError.response ? AxiosError.response.data.error : AxiosError.error;
  return error ? error.message : 'Error retrieving details';
};
